import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
import lodash from 'lodash';
import { verifyTrustDevice, checkUserMatch } from '@/assets/js/auth';
import Plugins from './plugins';

// 设置 EventEmitter 的最大监听器数量，避免内存泄漏警告
if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
  require('events').EventEmitter.defaultMaxListeners = 20;
}

import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.use(Plugins);
Vue.moment = moment;

import filters from './assets/js/filters'

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.scss';
import '@/assets/css/common.scss';
import '@/assets/css/animation.scss';
import '@/assets/css/public.scss';
import '@/assets/css/variable.scss';
import '@/assets/css/tailwindcss.css';


Vue.prototype._ = lodash;
Vue.prototype.lodash = lodash;
Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;

// 复制到剪贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

checkUserMatch();
verifyTrustDevice();

// "@sentry/browser": "^5.15.4",
//     "@sentry/integrations": "^5.15.4",
//     "@sentry/webpack-plugin": "^1.10.0",
// 增加sentry上报插件
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
// // 初始化sentry
// const VERSION = require('../version');
// const SentryDsn = process.env.VUE_APP_EVN==='dev' ?
//   '' :
//   ( process.env.VUE_APP_EVN==='staging' ? 'https://d4474c0e4f74437f837a1951ab62432d@staging-sentry.wondercv.cn/6' : 'https://63350e217131441a94d519287f23a6b5@sentry.wondercv.cn/5')
// console.log('main Sentry.init release=>',VERSION.release,SentryDsn)
// if(process.env.NODE_ENV === "production"){
//   Sentry.init({
//     release: VERSION.release,
//     dsn: SentryDsn,
//     // debug:true,
//     // logErrors: true,
//     integrations: [
//       new Integrations.Vue({
//         Vue,
//         attachProps: true // 是否上报组件的 props
//       }),
//       new Integrations.RewriteFrames() //<-----新增
//     ],
//     // beforeSend(event, hint) {
//     //     // Check if it is an exception, and if so, show the report dialog
//     //   if (event.exception) {
//     //     Sentry.showReportDialog({ eventId: event.event_id });
//     //   }
//     //   return event;
//     // }
//   })
//   window.Sentry = Sentry;
//   console.log('Sentry=>',Sentry)
// }

// 定义全局的filter
Object.keys(filters).forEach(i => {
	Vue.filter(i, filters[i])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
